"use client";

import type { TypographyProps } from "@mui/material";
import { Typography, Tooltip } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";

interface TextProps extends TypographyProps {
  showTooltipOnEllipse?: boolean;
  tooltipTitle?: React.ReactNode;
}

export const Text = ({
  showTooltipOnEllipse = true,
  noWrap,
  tooltipTitle = "",
  children,
  ...rest
}: TextProps) => {
  const [isOverflowed, setIsOverflowed] = useState(false);
  const textRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const compareWidths = (): void => {
      if (textRef.current) {
        const compare =
          textRef.current.scrollWidth > textRef.current.offsetWidth;
        setIsOverflowed(compare);
      }
    };

    compareWidths();

    window.addEventListener("resize", compareWidths);

    return () => {
      window.removeEventListener("resize", compareWidths);
    };
  }, [children]);

  const disabledTooltiop =
    !isOverflowed || !showTooltipOnEllipse || !noWrap || !tooltipTitle;

  return (
    <Tooltip
      arrow
      disableHoverListener={disabledTooltiop}
      placement="top"
      slotProps={{
        tooltip: {
          className: "body-m",
        },
      }}
      title={tooltipTitle ?? ""}
    >
      <Typography noWrap={noWrap} ref={textRef} {...rest}>
        {children}
      </Typography>
    </Tooltip>
  );
};
